<template>
  <div class="container">
    <TrfHeader pageTitle="Cadastro de modelos" />
    <div class="columns is-align-items-flex-end">
      <div class="column is-2-desktop is-12-mobile btn-container">
        <TrfButton
          v-if="usuarioTemPermissaoDeCriacao"
          @click="($event) => abrirCadastro()"
          nome="Novo modelo"
          classCor="is-primary"
          :temIcon="true"
          classIcon="mdi-plus"
          class="is-fullwidth"
          id="btn-novo-modelo"
        />
      </div>
    </div>
    <TrfModal
      :titulo="tituloModal"
      :btnSaveName="confirmacaoModal"
      :btnCloseName="cancelamentoModal"
      :isModalActive="isCadastroActive"
      :isBtnLoading="cadastroEmAndamento || loadingDepartamentos || loadingFuncionarios"
      @close="fecharCadastro"
      @save="async ($event) => await encadearCadastro()"
    >
      <div class="conteudo-modal">
        <TrfFormularioCadastroDeModelos
          ref="formularioModelo"
          v-show="etapaModal == 'cadastro'"
          :listaDeDepartamentos="listaDepartamentos"
          :listaDepartamentosFase="listaDepartamentosFase"
          :listaDeResponsaveis="listaResponsaveis"
          :loadingDepartamentos="loadingDepartamentos"
          :loadingResponsaveis="loadingFuncionarios"
          :modeloEmEdicao="modeloCadastro"
          @update:values="($event) => definirModeloCadastro($event)"
        ></TrfFormularioCadastroDeModelos>
        <div class="content" v-show="etapaModal == 'permissao'">
          <p>
            Identificamos que o(s) usuário(s) vinculado(s) na(s) fase(s) listada(s) abaixo, não possui as permissões necessárias para acessar o
            departamento vinculado ao modelo. Com isso, as fases relacionadas a esses departamento não estarão visíveis na área de dashboard do
            usuário.
          </p>
          <p>
            Para resolver esta situação será preciso ajustar o cadastro do(s) usuário(s) responsável(eis) concedendo a permissão a este departamento.
          </p>
          <p>
            <strong>Gostaria de conceder esta permissão a este(s) usuário(s)?</strong><br />
            OBS.: Caso não deseje conceder a permissão, será necessário atribuir um novo responsável para a fase que possua permissão para o
            departamento vinculado ao modelo.
          </p>

          <TrfTabela
            v-if="errosDePermissao.length > 0"
            :dataConfig="dataSourceErroPermissao"
            :data="errosDePermissao"
            :isButtonMoreHidden="true"
            :showDropdownOptions="false"
            :showButtonsDefault="true"
            dataStatus=""
            :isScrollAnexos="false"
            :showEdit="false"
            :showDelete="false"
            :shouldIgnorePreDelete="true"
          >
          </TrfTabela>
        </div>
      </div>
    </TrfModal>
    <div class="pt-2">
      <TrfTabela
        :tipoTabela="'tabela-modelos'"
        :dataConfig="this.dataSource"
        :data="listaDeModelosFormatada"
        :quantidadeDeItems="this.total"
        :nextPage="this.nextPage"
        :nextLimit="this.nextLimit"
        :showDropdownOptions="usuarioTemPermissaoNoModulo && (usuarioTemPermissaoDeEdicao || usuarioTemPermissaoDeExclusao)"
        :dataStatus="this.statusTable"
        @update:pagina="(pagina) => this.atualizarPagina(pagina)"
        @update:limite="(limite) => this.atualizarLimite(limite)"
        :paginaSelecionada="this.pagina"
        :limiteAtual="this.limite"
        textoNadaEncontrado="Nenhuma tarefa foi encontrada."
        tituloExclusao="Excluir modelo"
        :textoExclusao="textoExclusao"
        :showButtonsDefault="false"
        :showGlobalLoader="loadingTabela"
        :showEdit="usuarioTemPermissaoDeEdicao"
        :showDelete="usuarioTemPermissaoDeExclusao"
        :shouldIgnorePreDelete="false"
      />
    </div>
  </div>
</template>

<script>
import { pessoaLogada } from '../../stateManagement/pessoaLogada.js';
import { toastUtils } from '../../util/toast.utils.js';
import { defineAsyncComponent } from 'vue';
import ModeloDeTarefaModel from './model/modelo-de-tarefa.js';
import DOMPurify from 'dompurify';

export default {
  name: 'CadastroDeModelos',
  components: {
    TrfHeader: defineAsyncComponent(() => import('../../components/Header/index.vue')),
    TrfButton: defineAsyncComponent(() => import('../../components/Button/index.vue')),
    TrfTabela: defineAsyncComponent(() => import('../../components/Table/index.vue')),
    TrfModal: defineAsyncComponent(() => import('../../components/Modal/index.vue')),
    TrfFormularioCadastroDeModelos: defineAsyncComponent(() => import('../../components/FormularioCadastroDeModelos/index.vue'))
  },
  props: {
    statusTela: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      etapaModal: 'cadastro',
      isCadastroActive: false,
      cadastroEmAndamento: false,
      statusTable: '',
      dataSource: {
        columns: [
          {
            name: 'nome',
            label: 'Modelo',
            style: 'width:50%'
          },
          {
            name: 'departamento.nome',
            label: 'Departamento',
            style: 'width:40%'
          }
        ],
        selected: null,
        itens: [],
        select: (item) => {this.abrirCadastro(item)},
        preDelete: (item) => this.atribuirTextoExclusao(item),
        delete: (item) => this.excluir(item),
      },
      dataSourceErroPermissao: {
        columns: [
          {
            name: 'fase.ordem',
            label: 'Ordem'
          },
          {
            name: 'fase.nome',
            label: 'Fase'
          },
          {
            name: 'nomeResponsavel',
            label: 'Responsavel'
          }
        ],
        itens: [],
        itensSelected: [],
        itensDisabled: [],
        delete: async (item) => this.removerAnexo(item)
      },
      pagina: 1,
      total: 0,
      limite: 10,
      listaDeModelos: [],
      loadingDepartamentos: true,
      loadingFuncionarios: true,
      loadingTabela: true,
      listaDepartamentos: [],
      listaDepartamentosFase: [],
      listaResponsaveis: [],
      pessoaLogada: pessoaLogada.current,
      isSuperAdm: pessoaLogada.current.isSuperAdm,
      modeloCadastro: new ModeloDeTarefaModel(),
      errosDePermissao: [],
      textoExclusao: '',
    };
  },
  methods: {
    async adquirirDepartamentoService() {
      const { departamentoService } = await import('../../service/departamento-service.js');
      return departamentoService;
    },
    async adquirirDepartamentoPadraoService() {
      const { departamentoPadraoService } = await import('../../service/departamento-padrao-service.js');
      return departamentoPadraoService;
    },
    async adquirirUsuarioService() {
      const { usuarioService } = await import('../../service/usuario-service.js');
      return usuarioService;
    },
    async adquirirModeloService() {
      const { modeloService } = await import('../../service/modelo-service.js');
      return modeloService;
    },
    async adquirirPermissaoModeloService() {
      const { permissaoModeloService } = await import('../../service/permissao-modelo-service.js');
      return permissaoModeloService;
    },
    async listarFuncionarios() {
      this.loadingFuncionarios = true;
      const usuarioService = await this.adquirirUsuarioService();
      let funcionarios = await usuarioService.listarResponsaveis();
      if (!Array.isArray(funcionarios)) {
        funcionarios = [];
      }
      this.loadingFuncionarios = false;
      return funcionarios;
    },
    async listarDepartamentos() {
      this.loadingDepartamentos = true;
      const departamentoService = await this.adquirirDepartamentoService();
      let departamentos = await departamentoService.listar();

      if (!Array.isArray(departamentos)) {
        departamentos = [];
      }

      const departamentoPadraoService = await this.adquirirDepartamentoPadraoService();
      const departamentosPadroes = await departamentoPadraoService.listar();
      departamentosPadroes.forEach((departamentoPadrao) => {
        departamentos.push(departamentoPadrao);
      });
      this.loadingDepartamentos = false;

      departamentos = departamentos.map((departamento) => {
        return {
          value: departamento.value.toString(),
          label: departamento.label,
        };
      });
      return departamentos;
    },

    async listarDepartamentosFase() {
      this.loadingDepartamentos = true;

      if (!this.isSuperAdm) {
        const departamentoService = await this.adquirirDepartamentoService();
        let departamentos = await departamentoService.listarTodosDepartamentos();
        this.listaDepartamentosFase = departamentos.map((departamento) => {
          return {
            value: departamento?.value?.toString(),
            label: departamento?.label,
          };
        });
      } else {
        this.listaDepartamentosFase = this.listaDepartamentos;
      }

      this.loadingDepartamentos = false;
      return this.listaDepartamentosFase;
    },

    async abrirCadastro(item) {
      if (!this.usuarioTemPermissaoNoModulo || (!this.usuarioTemPermissaoDeCriacao && !this.usuarioTemPermissaoDeEdicao)) return;
      if (this.usuarioTemPermissaoDeEdicao && item && item.id != "") {
        this.modeloCadastro = JSON.parse(JSON.stringify(item));
        delete this.modeloCadastro.departamento;
        delete this.modeloCadastro.departamentoPadrao;
      } else if(this.usuarioTemPermissaoDeCriacao) {
        this.modeloCadastro = new ModeloDeTarefaModel();
      }
      this.isCadastroActive = true;
    },
    fecharCadastro() {
      if (this.etapaModal == 'permissao') {
        this.etapaModal = 'cadastro';
        this.errosDePermissao = [];
      } else {
        this.isCadastroActive = false;
        this.$refs.formularioModelo.limparFormulario();
        this.$refs.formularioModelo.definirFasesTemplates(null);
        this.modeloCadastro = new ModeloDeTarefaModel();
        this.etapaModal = 'cadastro';
        this.errosDePermissao = [];
      }
    },
    definirModeloCadastro(valor) {
      this.modeloCadastro = valor;
    },
    async encadearCadastro() {
      if (this.cadastroEmAndamento) return;
      const isValid = this.$refs.formularioModelo.checkValidity(true);
      if (!isValid) {
        return;
      }
      this.cadastroEmAndamento = true;
      try {
        let dadosModeloValidos, nomeModeloBase = '';
        if (this.modeloCadastro.id && this.modeloCadastro.id != "") {
          const modeloEmEdicao = this.listaDeModelos.find((modelo) => modelo.id == this.modeloCadastro.id);
          nomeModeloBase = modeloEmEdicao.nome;
        }
        if(!this.modeloCadastro.id || this.modeloCadastro.id == "" || nomeModeloBase.toLowerCase() != this.modeloCadastro.nome.toLowerCase()) {
          const permissaoModeloService = await this.adquirirPermissaoModeloService();
          dadosModeloValidos = await permissaoModeloService.verificarDados(this.modeloCadastroClone);
        }
        if (this.etapaModal == 'cadastro' && !!dadosModeloValidos && dadosModeloValidos.length > 0) {
          toastUtils.dangerToast(dadosModeloValidos[0].erro);
          throw dadosModeloValidos[0].erro;
        }

        if (!this.$refs.formularioModelo.isFasesAtivas()) {
          await this.salvarModelo();
        } else if (this.etapaModal == 'cadastro') {
          await this.verificarPermissaoCadastro();
        } else {
          await this.concederPermissaoDepartamentos();
          await this.salvarModelo();
        }
      } catch (e) {
        console.warn(`WARN: ${!!e.message ? e.message : e}`);
      }
      this.cadastroEmAndamento = false;
    },
    async concederPermissaoDepartamentos() {
      const permissaoModeloService = await this.adquirirPermissaoModeloService();
      const permissaoConcedida = await permissaoModeloService.atualizarPermissao(this.modeloCadastroClone);
    },
    async verificarPermissaoCadastro() {
      const permissaoModeloService = await this.adquirirPermissaoModeloService();
      const retornoPermissoes = await permissaoModeloService.verificarPermissao(this.modeloCadastroClone);
      this.errosDePermissao = this.montarListagemErrosDePermissao(retornoPermissoes);
      if (this.errosDePermissao.length > 0) {
        this.etapaModal = 'permissao';
      } else {
        await this.salvarModelo();
      }
    },
    montarListagemErrosDePermissao(falhasDePermissao) {
      if (!Array.isArray(falhasDePermissao)) {
        return [];
      }
      const listaOrdenada = [];
      falhasDePermissao.forEach((falha) => {
        if (
          !listaOrdenada.some((item) => {
            const isOrdemMatch = falha.fase.ordem == item.fase.ordem;
            const isNomeMatch = falha.fase.nome == item.fase.nome;
            const isResponsavelMatch = falha.nomeResponsavel == item.nomeResponsavel;
            return isOrdemMatch && isNomeMatch && isResponsavelMatch;
          })
        ) {
          listaOrdenada.push(falha);
        }
      });
      listaOrdenada.sort((a, b) => {
        if (a.fase.ordem < b.fase.ordem) {
          return -1;
        } else {
          return true;
        }
      });

      return listaOrdenada;
    },
    async salvarModelo() {
      this.cadastroEmAndamento = true;

      if (this.modeloCadastro?.complementoTemplate?.fasesTemplates?.length == 0) {
        delete this.modeloCadastro.complementoTemplate.fasesTemplates;
      }

      try {
        const modeloService = await this.adquirirModeloService();
        if (!this.modeloCadastro.id) {
          const resultados = await modeloService.cadastrar(this.modeloCadastro);
          toastUtils.successToast('Modelo cadastrado com sucesso!')
        } else {
          const resultados = await modeloService.editar(this.modeloCadastro);
          toastUtils.successToast('Modelo editado com sucesso!')
        }
        this.cadastroEmAndamento = false;
        this.isCadastroActive = false;
        this.etapaModal = 'cadastro';
        this.fecharCadastro();
        this._carregarListagem(true);
      } catch (e) {
        console.warn(`WARN: ${e}`);
      }
      this.cadastroEmAndamento = false;
    },
    async _carregarListagem(reset) {
      this.loadingTabela = true;
      try {
        if (reset) {
          this.pagina = '1';
        }
        const modeloService = await this.adquirirModeloService();

        const listaDeModelos = await modeloService.listar({
          'sort[DESC]': 'id',
          'bypassDepartamento': true,
          limit: this.limite,
          pagina: this.pagina
        });

        this.total = parseInt(listaDeModelos.totalDeItens);

        if (this.total === 0) {
          this.status = 'is-empty';
        } else {
          this.listaDeModelos = listaDeModelos.data;
          this.status = '';
        }
      } catch (e) {
        this.status = 'is-danger';
      }
      this.loadingTabela = false;
    },

    async nextPage(pagina) {
      this.pagina = pagina;

      this._carregarListagem();
    },
    async nextLimit(limite) {
      this.limite = limite;
      this._carregarListagem();
    },

    atualizarPagina(pagina) {
      this.pagina = pagina;
      this._carregarListagem();
    },

    atualizarLimite(limite) {
      this.limite = limite;
      this._carregarListagem();
    },

    atribuirTextoExclusao(modelo) {
        const nomeSanitizado = DOMPurify.sanitize(modelo.nome, { ALLOWED_TAGS: [] });
        this.textoExclusao = `Deseja excluir o modelo <strong>${nomeSanitizado}</strong>?`;
    },

    async excluir(modelo) {
      try {
        if (modelo.padrao) {
          toastUtils.dangerToast('Este modelo é padrão do sistema e não poderá ser excluído.');   
          return;
        }

        const modeloService = await this.adquirirModeloService();
        const resposta = await modeloService.apagar(modelo);

        if (resposta.ok) {
          toastUtils.successToast('Modelo excluído com sucesso!');
          const itemIndex = this.listaDeModelosFormatada.findIndex((item) => item.id === modelo.id);
          this.listaDeModelosFormatada.splice(itemIndex, 1);
        }
      } catch (e) {
        toastUtils.dangerToast('Erro ao tentar excluir o modelo!');
        console.error(e);
      }
    },
  },
  async mounted() {
    this.listaDepartamentos = await this.listarDepartamentos();
    await this.listarDepartamentosFase();
    this._carregarListagem();
    this.listaResponsaveis = await this.listarFuncionarios();
  },
  computed: {
    tituloModal() {
      let tituloModal = '';
      if (this.etapaModal == 'cadastro' && (this.modeloCadastro.id && this.modeloCadastro.id != "")) {
        tituloModal = 'Editar modelo';
      } else if (this.etapaModal == 'cadastro') {
        tituloModal = 'Cadastro de modelo'
      } else {
        tituloModal = 'Conceder permissão';
      }

      return tituloModal;
    },
    usuarioTemPermissaoDeAdmin() {
      return !this.pessoaLogada.Permissoes || this.pessoaLogada.isSuperAdm || this.pessoaLogada.Administrador;
    },
    usuarioTemPermissaoNoModulo() {
      return pessoaLogada.hasPermissao("AcessoTemplatesTarefas") || this.usuarioTemPermissaoDeAdmin;
    },
    usuarioTemPermissaoDeEdicao() {
      return this.usuarioTemPermissaoDeAdmin || (this.usuarioTemPermissaoNoModulo && this.pessoaLogada.Permissoes.Tarefas.Editar);
    },
    usuarioTemPermissaoDeCriacao() {
      return this.usuarioTemPermissaoDeAdmin || (this.usuarioTemPermissaoNoModulo && this.pessoaLogada.Permissoes.Tarefas.Criar);
    },
    usuarioTemPermissaoDeExclusao() {
      return this.usuarioTemPermissaoDeAdmin || (this.usuarioTemPermissaoNoModulo && this.pessoaLogada.Permissoes.Tarefas.Excluir);
    },
    listaDeModelosFormatada() {
      let cloneListaOriginal = [...this.listaDeModelos];
      cloneListaOriginal = cloneListaOriginal.map((modelo) => {
        const temPermissaoDepartamento = this.listaDepartamentos.some((departamento) => {
          return departamento.value == modelo.departamentoId || departamento.value == `P${modelo.departamentoPadraoId}`;
        })
        modelo.opcoesTabela = {
          editar: {
            disabled: !temPermissaoDepartamento || !this.usuarioTemPermissaoDeEdicao,
            disabledHint: "Usuários sem permissão para o departamento vinculado não podem realizar a edição do modelo.",
            hint: "Editar modelo"
          },
          excluir: {
            disabled: !temPermissaoDepartamento,
            disabledHint: "Usuários sem permissão para o departamento vinculado não podem realizar a exclusão do modelo.",
            hint: "Excluir modelo"
          }
        }
        return modelo;
      });
      return cloneListaOriginal;
    },
    modeloCadastroClone() {
      return Object.assign({}, this.modeloCadastro);
    },
    confirmacaoModal() {
      let confirmacaoModal = '';
      if (this.etapaModal == 'cadastro') {
        confirmacaoModal = 'Cadastrar';
      } else {
        confirmacaoModal = 'Sim';
      }

      return confirmacaoModal;
    },
    cancelamentoModal() {
      let cancelamentoModal = '';
      if (this.etapaModal == 'cadastro') {
        cancelamentoModal = 'Cancelar';
      } else {
        cancelamentoModal = 'Não';
      }

      return cancelamentoModal;
    }
  }
};
</script>

<style lang="scss" scoped>
.espaço-desktop {
  @media screen and (max-width: 600px) {
    display: none;
  }
}

.btn-container {
  @media screen and (max-width: 600px) {
    margin-right: 0;
  }

  @media screen and (min-width: 900px) {
    width: 150px;
    margin-right: auto;
  }
}
</style>
